<template>
  <header class="header_hero hero is-fullheight is-mobile">
    <section class="hero-body container">
      <h1 class="hero--section--title title_animation">
        <span class="ani1">行</span>
        <span class="ani2">き</span>
        <span class="ani3">場</span>
        <span class="ani4">の</span>
        <span class="ani5">な</span>
        <span class="ani6">い</span>
        <span class="ani7">二</span>
        <span class="ani8">人</span>
        <span class="ani9">は</span>
        <span class="ani10">、</span>
        <br class="is-hidden-tablet"><span class="ani11">家</span>
        <span class="ani12">族</span>
        <span class="ani13">に</span>
        <span class="ani14">な</span>
        <span class="ani15">っ</span>
        <span class="ani16">た</span>
        <span class="ani17">－</span>
      </h1>

      <h2 class="title_logo">
        <img src="/static/img/title.png" alt="名前">
        <strong class="seo">名前</strong>
      </h2>

      <figure class="actor_image actor_1">
        <img src="/static/img/photo01.png" alt="">
      </figure>
      <figure class="actor_image actor_2">
        <img src="/static/img/photo02.png" alt="">
      </figure>

      <ul>
        <li class="stamps stamp_0">
          <a href="/bd_dvd/">
            <img src="/static/img/btn_dvd-banner.png" alt="2019年7月2日（火）Blu-ray & DVDリリース！">
          </a>
        </li>
        <li class="stamps stamp_1">
          <img src="/static/img/stamp01.png" alt="Stamp 1">
        </li>
        <li class="stamps stamp_2">
          <img src="/static/img/stamp02.png" alt="Stamp 2">
        </li>
        <li class="stamps stamp_3">
          <img src="/static/img/stamp03.png" alt="Stamp 1">
        </li>
        <li class="stamps stamp_4">
          <img src="/static/img/title_en.png" alt="The Name">
        </li>
      </ul>

      <figure class="intro_text">
        <img src="/static/img/text03.png" alt="">
      </figure>

      <!-- <p class="intro_text">直木賞作家 道尾秀介 原案
      <br>行き場のない二人は、家族になった―</p> -->
    </section>
  </header>
</template>

<script>
// import Vue from 'vue'

export default {
  name: 'hero',
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Hero.vue